var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDobleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    width: 34,
    height: 34,
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 34 34"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill-rule:evenodd;clip-rule:evenodd}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.369 7.771 7.78 22.377l-5.833-5.785L0 18.513l7.78 7.716L24.452 9.702zM31.917 7.771 17.33 22.377l-1.575-1.56-1.944 1.924 3.519 3.488L34 9.702z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDobleCheck);
export default __webpack_public_path__ + "static/media/doble-check.efdc97fc3f97371ed227230aaa13c35b.svg";
export { ForwardRef as ReactComponent };